import { UploadOutlined } from "@ant-design/icons";
import { DEFAULT_TOOLBAR_MOUSE_ENTER_DELAY } from "@org-avp/avp-avengers-ui-shared-utils";
import { Button, ButtonProps, Tooltip, TooltipProps, Upload, UploadProps } from "antd";
import { FC, ReactNode, useMemo } from "react";

export type UploadButtonProps = ButtonProps & {
  icon?: ReactNode;
  tooltipTitle: string;

  accept?: string;
  customRequest: UploadProps["customRequest"];
  itemRender?: UploadProps["itemRender"];

  tooltipPlacement?: TooltipProps["placement"];
  mouseEnterDelay?: TooltipProps["mouseEnterDelay"];
};

export const UploadButton: FC<UploadButtonProps> = (
  {
    icon,
    tooltipTitle,
    accept,
    customRequest,
    itemRender,
    ...props
  },
) => {
  const mouseEnterDelay = useMemo(() => {
    const delay = props.mouseEnterDelay;
    return delay !== undefined ? delay : DEFAULT_TOOLBAR_MOUSE_ENTER_DELAY;
  }, [props.mouseEnterDelay]);

  return (
    <Tooltip title={tooltipTitle} placement={props.tooltipPlacement} mouseEnterDelay={mouseEnterDelay}>
      <Upload
        accept={accept}
        customRequest={customRequest}
        itemRender={itemRender ?? (() => undefined)} // suppress list of uploaded files below the button
      >
        <Button icon={icon ?? <UploadOutlined/>} {...props}/>
      </Upload>
    </Tooltip>
  );
};
